import { render, staticRenderFns } from "./messageAgent.vue?vue&type=template&id=6f54b675&scoped=true&"
import script from "./messageAgent.vue?vue&type=script&lang=js&"
export * from "./messageAgent.vue?vue&type=script&lang=js&"
import style0 from "./messageAgent.vue?vue&type=style&index=0&id=6f54b675&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f54b675",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f54b675')) {
      api.createRecord('6f54b675', component.options)
    } else {
      api.reload('6f54b675', component.options)
    }
    module.hot.accept("./messageAgent.vue?vue&type=template&id=6f54b675&scoped=true&", function () {
      api.rerender('6f54b675', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resource/messageAgent.vue"
export default component.exports